var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import toast from '../../components/Toast';
var MediaService = services.MediaService, TemplatesService = services.TemplatesService, AppService = services.AppService;
export var addBasicDetails = function (basicDetails) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'CREATE_BASIC_TEMPLATE_SUCCESS',
                basicDetails: basicDetails,
            });
        }
        catch (error) {
            dispatch({
                type: 'CREATE_BASIC_TEMPLATE_FAILURE',
                error: error,
            });
        }
        return [2 /*return*/];
    });
}); }; };
export var changeDeletePopupState = function (deletePopup) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'UPDATE_ENVIRONMENT_DELETE_POPUP_SUCCESS',
                    deletePopup: deletePopup,
                });
            }
            catch (error) {
                dispatch({
                    type: 'UPDATE_ENVIRONMENT_DELETE_POPUP_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var changeResetPopupState = function (resetEnvPopup) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'UPDATE_ENVIRONMENT_RESET_POPUP_SUCCESS',
                    resetEnvPopup: resetEnvPopup,
                });
            }
            catch (error) {
                dispatch({
                    type: 'UPDATE_ENVIRONMENT_RESET_POPUP_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var addTemplateId = function (templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'ADD_TEMPLATE_ID_SUCCESS',
                templateId: templateId,
            });
        }
        catch (error) {
            dispatch({
                type: 'ADD_TEMPLATE_ID_FAILURE',
                error: error,
            });
        }
        return [2 /*return*/];
    });
}); }; };
export var changeSectionState = function (sectionNumber) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'UPDATE_SECTION_NUMBER_SUCCESS',
                    sectionNumber: sectionNumber,
                });
            }
            catch (error) {
                dispatch({
                    type: 'UPDATE_SECTION_NUMBER_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var updateHeaderName = function (header, id) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'UPDATE_SECTION_HEADER_SUCCESS',
                    header: header,
                    id: id,
                });
            }
            catch (error) {
                dispatch({
                    type: 'UPDATE_SECTION_HEADER_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var removeHeader = function (id) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'REMOVE_SECTION_HEADER_SUCCESS',
                id: id,
            });
            dispatch({
                type: 'REMOVE_SECTION_ENV_SUCCESS',
                id: id,
            });
        }
        catch (error) {
            dispatch({
                type: 'REMOVE_SECTION_HEADER_FAILURE',
                error: error,
            });
        }
        return [2 /*return*/];
    });
}); }; };
export var addSelectedView = function (selectedViews) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'CREATE_SELECTED_VIEW_ADD_SUCCESS',
                    selectedViews: selectedViews,
                });
            }
            catch (error) {
                dispatch({
                    type: 'CREATE_SELECTED_VIEW_ADD_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var changeCurrentPage = function (currentStep) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch({
            type: 'CHANGE_CURRENT_STEP_SUCCESS',
            currentStep: currentStep,
        });
        return [2 /*return*/];
    });
}); }; };
export var addPersonalization = function (personalization) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                dispatch({
                    type: 'CREATE_PERSONALIZATION_TEMPLATE_SUCCESS',
                    personalization: personalization,
                });
            }
            catch (error) {
                dispatch({
                    type: 'CREATE_PERSONALIZATION_TEMPLATE_FAILURE',
                    error: error,
                });
            }
            return [2 /*return*/];
        });
    }); };
};
export var updateEnvironmentVariables = function (env) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({
                type: 'UPDATE_ENVIRONMENT_VARIABLES_SUCCESS',
                env: env,
            });
        }
        catch (error) {
            dispatch({
                type: 'UPDATE_ENVIRONMENT_VARIABLES_FAILURE',
                error: error,
            });
        }
        return [2 /*return*/];
    });
}); }; };
export var getFiles = function (scope) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, files, meta, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'STATE_LOAD_FILES_REQUEST' });
                return [4 /*yield*/, MediaService.getFiles(scope)];
            case 1:
                _a = _b.sent(), files = _a.objects, meta = _a.meta;
                dispatch({ type: 'STATE_LOAD_FILES_SUCCESS', files: files, meta: meta });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                dispatch({ type: 'STATE_LOAD_FILES_FAILURE', err: err_1 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteEnvironments = function (templateId, environmentId, section) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ENVIRONMENT_DELETE_REQUEST' });
                    return [4 /*yield*/, TemplatesService.deleteTemplateEnv(templateId, environmentId, section)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ENVIRONMENT_DELETE_SUCCESS' });
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    dispatch({ type: 'ENVIRONMENT_DELETE_FAILURE', err: err_2 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var resetTemplate = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({ type: 'RESET_TEMPLATE_SUCCESS' });
        }
        catch (err) {
            dispatch({ type: 'RESET_TEMPLATE_FAILURE', err: err });
        }
        return [2 /*return*/];
    });
}); }; };
export var getApp = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var appData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, AppService.getApp(appId)];
            case 1:
                appData = (_a.sent()).object;
                dispatch({
                    type: 'UPDATE_TEMPLATE_DATA_SUCCESS',
                    appData: appData,
                });
                return [2 /*return*/, (appData === null || appData === void 0 ? void 0 : appData.template) || ''];
            case 2:
                error_1 = _a.sent();
                dispatch({
                    type: 'UPDATE_TEMPLATE_DATA_FAILURE',
                    error: error_1,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteTemplate = function (templateId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'DELETE_APP_TEMPLATES_REQUEST' });
                return [4 /*yield*/, TemplatesService.deleteTemplate(templateId)];
            case 1:
                _a.sent();
                dispatch({ type: 'DELETE_APP_TEMPLATES_SUCCESS', templateId: templateId });
                toast.success('Template deleted');
                return [3 /*break*/, 3];
            case 2:
                err_3 = _a.sent();
                dispatch({ type: 'DELETE_APP_TEMPLATES_FAILURE', err: err_3 });
                toast.error('An error occurred while deleting the template');
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
